/* eslint-disable no-param-reassign */
import axios from 'axios';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import translationMap from '../../translationMap';

/*
 * Originally, a fork of https://github.com/angular-translate/angular-translate/blob/master/src/service/loader-static-files.js
 * Subsequently, de-Angular-ifed and es6-ified to reuse for 100%-React Widget
 */

const i18nLoaderReact = {
  load: (options) => {
    window.translationMap = translationMap || {};

    if (!options || (!isArray(options.files) && (!isString(options.prefix) || !isString(options.suffix)))) {
      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
    }

    if (!options.files) {
      options.files = [{
        prefix: options.prefix,
        suffix: options.suffix,
      }];
    }

    const load = (file) => {
      if (!file || (!isString(file.prefix) || !isString(file.suffix))) {
        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
      }

      let fileUrl = [file.prefix, options.key, file.suffix].join('');
      if (isObject(options.fileMap) && options.fileMap[fileUrl]) {
        fileUrl = options.fileMap[fileUrl];
      }

      return axios({ url: fileUrl, method: 'GET' })
        .then((result) => result.data)
        .catch(() => ({ key: options.key }));
    };

    const promises = [];
    const { length } = options.files;
    for (let i = 0; i < length; i++) {
      promises.push(load({
        prefix: options.files[i].prefix,
        key: options.key,
        suffix: options.files[i].suffix,
      }));
    }

    return Promise.all(promises)
      .then((translatations) => {
        const mergedData = {};

        for (let i = 0; i < translatations.length; i++) {
          // eslint-disable-next-line no-shadow
          const translationMap = translatations[i];
          Object.keys(translationMap).forEach((key) => {
            mergedData[key] = translationMap[key];
          });
        }

        window.translationMap = mergedData;
        return mergedData;
      });
  },
};

export default i18nLoaderReact;
